/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  TextField,
} from "@material-ui/core";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import ButtonFooter from "components/ButtonFooter";
import { useEffect } from "react";
import {
  getAccountCodeList,
  getDepartmentList,
  getTaxAllocation,
  updateTaxAllocation,
} from "services/setting";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getTaxProfile } from "services/accountPayable";
import SnackbarUtils from "utils/SnackbarUtils";
import NumberFormatInput from "components/NumberFormatInput";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { matchSorter } from "match-sorter";
import ListBox from "components/ListBox";
import PopperListBox from "components/PopperListBox";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: "#1976d2",
    color: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
  },
  rootTitle: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  rateInput: {
    width: "100px",
    textAlign: "right",
  },
  selectSmall: {
    width: "100%",
    height: theme.spacing(2.5),
    fontSize: "0.875rem",
  },
  totalCell: {
    fontWeight: "bold",
  },
  totalValue: {
    color: "#4caf50",
  },
  noteText: {
    color: theme.palette.text.secondary,
    fontSize: "0.75rem",
  },
}));

const DialogSettingInputTax = ({ open, onClose, onSave }) => {
  const classes = useStyles();
  const [isBtnLoading, setBtnLoading] = React.useState(false);
  const [data, setData] = useStateWithCallbackLazy();
  const [lookupList, setLookupList] = React.useState({
    accountCodeList: [],
    departmentList: [],
    taxProfileList: [],
  });

  const Save = async () => {
    console.log(data);
    const { Code, UserMessage } = await updateTaxAllocation(data);
    if (Code === 0) {
      SnackbarUtils.success(UserMessage);
      handleClose();
    }
    setBtnLoading(false);
  };

  const handleClose = () => {
    onClose();
  };

  const fetchTaxProfile = async () => {
    const { Data } = await getTaxProfile();
    setLookupList((state) => ({
      ...state,
      taxProfileList: Data,
    }));
  };
  const fetchAccLookup = async () => {
    const { Data } = await getAccountCodeList("Gl");
    setLookupList((state) => ({
      ...state,
      accountCodeList: Data,
    }));
  };
  const fetchDeptLookup = async () => {
    const { Data } = await getDepartmentList();
    setLookupList((state) => ({
      ...state,
      departmentList: Data,
    }));
  };

  const fetchDetail = async () => {
    const response = await getTaxAllocation();
    console.log(response.Data);
    if (response) {
      setData(response.Data);
    }

    setBtnLoading(false);
  };

  useEffect(() => {
    fetchDetail();
    fetchTaxProfile();
    fetchAccLookup();
    fetchDeptLookup();
  }, []);

  const handleRateChange = (id, value) => {
    const newRate = parseFloat(value) || 0;

    // Only process if this is Tax 1 (Claim)
    if (id === 1) {
      // Validate that the rate is between 1-100
      const validatedRate = Math.max(1, Math.min(100, newRate));

      setData((prev) => {
        // Calculate Tax 2 as 100 - Tax 1
        const tax2Rate = 100 - validatedRate;

        return prev.map((tax) => {
          if (tax.TaxAllocationId === 1) {
            return { ...tax, Percent: validatedRate };
          } else if (tax.TaxAllocationId === 2) {
            return { ...tax, Percent: tax2Rate };
          }
          return tax;
        });
      });
    } else {
      // For Tax 2, just update as normal
      setData((prev) =>
        prev.map((tax) =>
          tax.TaxAllocationId === id ? { ...tax, Percent: newRate } : tax,
        ),
      );
    }
  };

  const totalRate = data?.reduce((sum, tax) => sum + tax.Percent, 0);

  const DialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <MuiDialogTitle
        disableTypography
        className={classes.rootTitle}
        {...other}
      >
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  const filterOptions = (options, { inputValue }, optKey, optDesc) => {
    return matchSorter(options, inputValue, {
      keys: [`${optKey}`, `${optDesc}`],
    });
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      aria-labelledby="confirmation-dialog-title"
      open={open}
    >
      <DialogTitle id="customized-dialog-title" onClose={onClose}>
        Input Tax Allocation Setup
      </DialogTitle>

      <DialogContent dividers>
        <Table>
          <TableHead style={{ backgroundColor: "#f5f5f5" }}>
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Tax</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Rate %</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Tax Profile</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Dept. Code</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Account Code</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((tax) => (
              <TableRow key={tax.id}>
                <TableCell>
                  <Typography
                    variant="body2"
                    style={{
                      color: tax.Name.includes("(Claim)")
                        ? "#4caf50"
                        : "#757575",
                      fontWeight: tax.Name.includes("(Claim)")
                        ? "bold"
                        : "normal",
                    }}
                  >
                    {tax.Name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    inputProps={{ style: { textAlign: "right" } }}
                    InputProps={{
                      inputComponent: NumberFormatInput,
                    }}
                    value={tax.Percent}
                    onChange={(e) =>
                      handleRateChange(tax.TaxAllocationId, e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    style={{ width: 160 }}
                    options={lookupList["taxProfileList"]}
                    disableClearable
                    disableListWrap
                    value={tax.TaxProfileCode}
                    onChange={(e, newItem) => {
                      setData((prev) =>
                        prev.map((t) =>
                          t.TaxAllocationId === tax.TaxAllocationId
                            ? {
                                ...t,
                                TaxProfileCode: newItem.TaxProfileCode,
                              }
                            : t,
                        ),
                      );
                    }}
                    ListboxComponent={ListBox}
                    PopperComponent={PopperListBox}
                    classes={{
                      option: classes.option,
                    }}
                    getOptionLabel={(option) => {
                      return typeof option === "object" ? option.Code : option;
                    }}
                    getOptionSelected={(option, value) => option.Code === value}
                    renderOption={(option, { inputValue }) => {
                      const mergestring = `${option.Code} : ${option.Description}`;

                      const matches = match(mergestring, inputValue);
                      const parts = parse(mergestring, matches);
                      return (
                        <div>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{ fontWeight: part.highlight ? 700 : 400 }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      );
                    }}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label={`* Tax Profile ${tax.TaxAllocationId}`}
                        margin="dense"
                      />
                    )}
                    filterOptions={(options, { inputValue }) =>
                      filterOptions(
                        options,
                        { inputValue },
                        "Code",
                        "Description",
                      )
                    }
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    style={{ width: 160 }}
                    options={lookupList["departmentList"]}
                    disableClearable
                    disableListWrap
                    value={tax.DeptCode}
                    onChange={(e, newItem) => {
                      setData((prev) =>
                        prev.map((t) =>
                          t.TaxAllocationId === tax.TaxAllocationId
                            ? {
                                ...t,
                                DeptCode: newItem.DeptCode,
                                DepartmentDesc: newItem.Description,
                              }
                            : t,
                        ),
                      );
                    }}
                    ListboxComponent={ListBox}
                    PopperComponent={PopperListBox}
                    classes={{
                      option: classes.option,
                    }}
                    getOptionLabel={(option) => {
                      return typeof option === "object"
                        ? option.DeptCode
                        : option;
                    }}
                    getOptionSelected={(option, value) =>
                      option.DeptCode === value
                    }
                    renderOption={(option, { inputValue }) => {
                      const mergestring = `${option.DeptCode} : ${option.Description}`;

                      const matches = match(mergestring, inputValue);
                      const parts = parse(mergestring, matches);
                      return (
                        <div>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{ fontWeight: part.highlight ? 700 : 400 }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      );
                    }}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Department"
                        margin="dense"
                      />
                    )}
                    filterOptions={(options, { inputValue }) =>
                      filterOptions(
                        options,
                        { inputValue },
                        "DeptCode",
                        "Description",
                      )
                    }
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    style={{ width: 160 }}
                    options={lookupList["accountCodeList"]}
                    disableClearable
                    disableListWrap
                    value={tax.AccCode}
                    onChange={(e, newItem) => {
                      setData((prev) =>
                        prev.map((t) =>
                          t.TaxAllocationId === tax.TaxAllocationId
                            ? {
                                ...t,
                                AccCode: newItem.AccCode,
                                AccDesc: newItem.Description,
                              }
                            : t,
                        ),
                      );
                    }}
                    ListboxComponent={ListBox}
                    PopperComponent={PopperListBox}
                    classes={{
                      option: classes.option,
                    }}
                    getOptionLabel={(option) => {
                      return typeof option === "object"
                        ? option.AccCode
                        : option;
                    }}
                    getOptionSelected={(option, value) =>
                      option.AccCode === value
                    }
                    renderOption={(option, { inputValue }) => {
                      const mergestring = `${option.AccCode} : ${option.Description}`;

                      const matches = match(mergestring, inputValue);
                      const parts = parse(mergestring, matches);
                      return (
                        <div>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{ fontWeight: part.highlight ? 700 : 400 }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      );
                    }}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Account Code"
                        margin="dense"
                      />
                    )}
                    filterOptions={(options, { inputValue }) =>
                      filterOptions(
                        options,
                        { inputValue },
                        "AccCode",
                        "Description",
                      )
                    }
                  />
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Total:</TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  color: totalRate === 100 ? "#4caf50" : "red",
                }}
                className={classes.totalCell}
              >
                {totalRate?.toFixed(2)}%
              </TableCell>
              <TableCell colSpan={3}>
                <Typography variant="caption" className={classes.noteText}>
                  *ผลรวมต้องเท่ากับ 100% เสมอ
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </DialogContent>

      <DialogActions>
        <ButtonFooter
          noBorder
          disabled={isBtnLoading}
          SaveFnc={() => Save()}
          CancelFnc={() => handleClose()}
        />
      </DialogActions>
      <pre>
        {process.env.NODE_ENV === "development"
          ? JSON.stringify(data, 0, 2)
          : ""}
      </pre>
    </Dialog>
  );
};

export default DialogSettingInputTax;
